import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "babySeatFilled"
const BabySeatFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 3.375Q12.43 3.375 12.85 3.417C13.106 3.567 13.32 3.781 13.466 4.04 13.617 4.304 13.694 4.605 13.688 4.91S13.592 5.512 13.43 5.77C13.27 6.028 13.04 6.238 12.77 6.377S12.194 6.58 11.89 6.56 11.293 6.437 11.042 6.264C10.792 6.091 10.592 5.854 10.465 5.577L9.442 6.044C9.652 6.506 9.985 6.902 10.403 7.19S11.31 7.65 11.817 7.682 12.83 7.61 13.283 7.378C13.735 7.147 14.116 6.797 14.385 6.366 14.654 5.936 14.8 5.44 14.812 4.932 14.82 4.532 14.74 4.136 14.585 3.771 17.19 4.589 19.26 6.609 20.15 9.18 21.302 9.602 22.125 10.704 22.125 12S21.301 14.398 20.15 14.817C18.983 18.196 15.777 20.625 12 20.625S5.016 18.196 3.848 14.817C2.698 14.397 1.875 13.297 1.875 12S2.698 9.6 3.848 9.182C5.016 5.802 8.223 3.375 12 3.375M12 15.563C11.275 15.563 10.688 16.15 10.688 16.875S11.275 18.188 12 18.188 13.313 17.6 13.313 16.875 12.725 15.563 12 15.563M8.25 10.313C7.98 10.313 7.71 10.366 7.46 10.469S6.983 10.725 6.792 10.917C6.6 11.108 6.448 11.335 6.344 11.585 6.241 11.835 6.188 12.105 6.187 12.375H7.313Q7.313 12.189 7.385 12.016 7.455 11.844 7.587 11.712 7.72 11.581 7.891 11.51 8.064 11.437 8.25 11.437T8.609 11.51Q8.78 11.58 8.913 11.712 9.044 11.844 9.116 12.016 9.187 12.19 9.188 12.375H10.312C10.313 12.105 10.26 11.835 10.157 11.585S9.9 11.108 9.708 10.917C9.517 10.725 9.29 10.573 9.04 10.469 8.79 10.366 8.52 10.313 8.25 10.313M15.375 10.313C15.105 10.313 14.835 10.366 14.585 10.469S14.108 10.725 13.917 10.917C13.725 11.108 13.573 11.335 13.469 11.585 13.366 11.835 13.313 12.105 13.313 12.375H14.437Q14.438 12.189 14.51 12.016 14.58 11.844 14.712 11.712 14.844 11.581 15.016 11.51 15.19 11.437 15.375 11.437T15.734 11.51Q15.906 11.58 16.038 11.712 16.169 11.844 16.24 12.016 16.313 12.19 16.313 12.375H17.438C17.438 12.105 17.384 11.835 17.28 11.585S17.025 11.108 16.833 10.917C16.642 10.725 16.415 10.573 16.165 10.469 15.915 10.366 15.645 10.313 15.375 10.313"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BabySeatFilledIcon
